{
  "takim": {
    "Baslik": "Teams",
    "Liste": "Team Lijst",
    "Yeni Ekle": "Nieuw Team Toevoegen",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Yenile": "Vernieuwen",
    "Duzenle": "Bewerken",
    "Sil": "Verwijderen",
    "Durum": "Status",
    "Kullanici Ata": "Personeel Toewijzen",
    "Ad": "Team Naam",
    "Kayit Sil": "Record Verwijderen",
    "Sil Onay": "Weet u zeker dat u dit team wilt verwijderen? Alle gebruikers in het team worden ook verwijderd.",
    "Iptal": "Annuleren",
    "Kaydet": "Opslaan",
    "Guncelle": "Bijwerken",
    "Aktif": "Actief",
    "Pasif": "Passief",
    "Ekle": "Toevoegen",
    "Yonetici": "Is Manager?",
    "Tümü": "Alle",
    "Kapat": "Sluiten",
    "Personeller": "Personeel in Team",
    "Personel Secin": "Selecteer Personeel...",
    "Henuz Personel Yok": "Nog geen personeel in het team."
  },
  "takim_hedef": {
    "Baslik": "Takım Hedef Tanımları",
    "Firma-Ürün": "Firma-Ürün",
    "Satış Group": "Satış Group",
    "Tutar": "Tutar",
    "Ekle": "Hedef Ekle",
    "Hedef Ekle": "Yeni Hedef Tanımla",
    "Hedef Güncelle": "Hedef Güncelle",
    "Düzeltme": "Düzeltme",
    "Sil": "Sil",
    "Data Yenile": "Verileri Güncelle",
    "Örn": "Örnek",
    "Kaydet": "Kaydet",
    "Güncelle": "Güncelle",
    "İptal": "İptal",
    "Ürün": "Ürün",
    "Seçiniz": "Seçiniz"
  }
}
